export interface RBACRolesResponse {
  userId: string;
  roles: RBACRole[];
  businessActivities: BusinessAction[];
}

export enum RBACRole {
  CORPORATE_PARTS_MANAGER = "CORPORATE_PARTS_MANAGER",
  CORPORATE_VIEW = "CORPORATE_VIEW",
  VIEW_ACCESS = "VIEW_ACCESS",
  ORDER_ADMIN = "ORDER_ADMIN",
  CLAIMS_RETURNS_ADMIN = "CLAIMS_RETURNS_ADMIN",
  JD_ADMIN = "JD_ADMIN",
  JD_SUPER_ADMIN = "JD_SUPER_ADMIN",
  JD_READ_ONLY = "JD_READ_ONLY",
  JD_DEVELOPER_ADMIN = "JD_DEVELOPER_ADMIN",
  JDPS_SERVICE_DEALER = "JDPS_SERVICE_DEALER",
  PROMOTION_TRACKER = "PROMOTION_TRACKER",
}
export enum BusinessAction {
  EDIT_ACCOUNT_PREFERENCE = "EDIT_ACCOUNT_PREFERENCE",
  VIEW_ACCOUNT_PREFERENCE = "VIEW_ACCOUNT_PREFERENCE",
  VIEW_CREDIT_STATUS = "VIEW_CREDIT_STATUS",
  EDIT_FEATURE_TOGGLE = "EDIT_FEATURE_TOGGLE",
  VIEW_FEATURE_TOGGLE = "VIEW_FEATURE_TOGGLE",
  EDIT_RETURN = "EDIT_RETURN",
  CREATE_RETURN = "CREATE_RETURN",
  EDIT_CLAIM = "EDIT_CLAIM",
  CREATE_CLAIM = "CREATE_CLAIM",
  EDIT_ORDER = "EDIT_ORDER",
  CREATE_ORDER = "CREATE_ORDER",
  VIEW_PART_INFORMATION = "VIEW_PART_INFORMATION",
  VIEW_PROMOTIONS = "VIEW_PROMOTIONS",
  VIEW_RETURNS = "VIEW_RETURNS",
  VIEW_INVOICES = "VIEW_INVOICES",
  VIEW_CLAIMS = "VIEW_CLAIMS",
  VIEW_ORDERS = "VIEW_ORDERS",
  VIEW_MY_DASHBOARD = "VIEW_MY_DASHBOARD",
  VIEW_HANDLING_UNITS = "VIEW_HANDLING_UNITS",
  VIEW_ELIGIBILITIES = "VIEW_ELIGIBILITIES",
  PROMOTION_TRACKER = "PROMOTION_TRACKER",
  CORPORATE_VIEW = "CORPORATE_VIEW",
}

export interface BffRBACRolesResponse {
  userId: string;
  roles: string[];
  businessActivities: string[];
}
